{
  "Sidebar": {
    "badges": {
      "beta": "Beta"
    },
    "guest": {
      "title": "Save your work",
      "description": "Sign up for free to permanently save your exams, chats, and settings.",
      "loginButton": "Login Now"
    },
    "actions": {
      "newExamTitle": "Create new exam",
      "creating": "Creating...",
      "newExam": "New Exam"
    },
    "examList": {
      "title": "My Exams",
      "noExams": "No exams found.",
      "unnamed": "Untitled",
      "unnamedExam": "Untitled Exam",
      "loadOlder": "Load older exams"
    },
    "examMenu": {
      "edit": "Edit",
      "addToClass": "Add to Class",
      "delete": "Delete"
    },
    "bottomNav": {
      "profile": "Profile",
      "settings": "Settings",
      "feedback": "Give Feedback",
      "classroom": "Classroom",
      "joinClass": "Join class"
    },
    "dialogs": {
      "renameTitle": "Edit Exam",
      "groupTitle": "Group Exam",
      "renameDesc": "Edit the information of this exam.",
      "groupDesc": "Select a class or group for this exam.",
      "fields": {
        "name": "Name",
        "subject": "Subject",
        "topic": "Topic",
        "class": "Class",
        "placeholderSelect": "Please select..."
      },
      "save": "Save"
    },
    "alerts": {
      "deleteConfirm": "Are you sure you want to delete this exam?",
      "saveFailed": "Save failed"
    }
  },
  "Settings": {
    "title": "Settings",
    "soon": "Coming Soon",
    "DisplayAndLanguage": {
      "title": "Display & Language",
      "languageLabel": "Language",
      "languageDesc": "Choose the interface language.",
      "themeLabel": "Appearance",
      "themeDesc": "Switch between light and dark mode."
    },
    "AI": {
      "title": "AI & Grading",
      "strictnessLabel": "AI Uncertainty",
      "strictnessDesc": "Determines at which AI confidence level manual review is mandatory.",
      "strictnessWarning": "Warning: With \"High Autonomy\", you only intervene manually when the AI is highly uncertain...",
      "gradingKindnessLabel": "Grading Strictness",
      "gradingKindnessDesc": "Determines how strictly the AI applies the grading scheme. Lenient favors the student in borderline cases; Strict follows the scheme exactly.",
      "gradingKindnessOptions": {
        "lenient": "Lenient",
        "balanced": "Balanced",
        "strict": "Strict"
      }
    },
    "Notifications": {
      "title": "Notifications",
      "soon": "Coming Soon",
      "emailLabel": "Email Notifications",
      "emailDesc": "Receive email notifications about important events.",
      "browserLabel": "Browser Notifications",
      "browserDesc": "Receive push notifications directly in your browser."
    },
    "About": {
      "title": "About Gradias",
      "landingPage": "Visit gradias.ai",
      "support": "Help & Support",
      "imprint": "Legal Notice",
      "privacy": "Privacy Policy"
    },
    "Account": {
      "title": "Data & Account",
      "exportLabel": "Export my data",
      "exportDesc": "Download all uploaded exams and results as a ZIP file.",
      "deleteLabel": "Delete my account",
      "deleteDesc": "Permanently delete your account and all associated data."
    }
  },
  "Profile": {
    "title": "Profile",
    "actions": {
      "cancel": "Cancel",
      "save": "Save",
      "edit": "Edit",
      "remove": "Remove"
    },
    "alerts": {
      "saveError": "Profile could not be saved.",
      "generalError": "An error occurred."
    },
    "personal": {
      "firstName": "First Name",
      "lastName": "Last Name",
      "name": "Name",
      "school": "School",
      "noSchool": "No school provided",
      "email": "Email",
      "emailHint": "Email cannot be changed here.",
      "defaultUser": "User",
      "role": {
        "teacher": "Teacher",
        "student": "Student"
      }
    },
    "teaching": {
      "subjects": "My Subjects",
      "addSubjectPlaceholder": "Search or type a subject…",
      "addCustomSubject": "Add \"{{value}}\""
    },
    "rules": {
      "title": "Rules & Preferences",
      "description": "Saved preferences the assistant follows — when chatting, grading, and creating master solutions and grading schemes. You can edit them here yourself, but the assistant can also adjust them for you right in the chat.",
      "general": "General",
      "empty": "No rules saved yet.",
      "addRule": "Add rule",
      "removeRule": "Remove rule",
      "limitReached": "Limit reached",
      "limitHint": "Up to {{max}} rules per category",
      "placeholder": "Describe a rule …",
      "categories": {
        "chat_and_workflow": "Chat & Workflow",
        "grading_and_feedback": "Grading & Feedback",
        "master_solution_design": "Master Solutions",
        "grading_scheme_creation": "Grading Schemes"
      },
      "categoryDescs": {
        "chat_and_workflow": "How the assistant replies in chat and runs the workflow",
        "grading_and_feedback": "How answers are graded and feedback is written",
        "master_solution_design": "How master solutions are created",
        "grading_scheme_creation": "How grading schemes are built"
      },
      "grammar": {
        "alwaysUseFi": "Always use the Fehlerindex (error index)",
        "alwaysUseFiDesc": "By default, uses the error index instead of any detected grammar rules from an uploaded grading scheme. Can be overridden per exam.",
        "languageUseRegradeWordCutoff": "Auto-regrade language use after (words)",
        "languageUseRegradeWordCutoffDesc": "When a student answer is edited, the affected group's language use is automatically re-graded once at least this many words have changed (several small edits add up).",
        "contentRegradeWordCutoff": "Auto-regrade content after (words)",
        "contentRegradeWordCutoffDesc": "0 = always (default) — content is re-graded immediately on any text change. A higher value skips the automatic regrade for very small edits."
      }
    },
    "security": {
      "title": "Account & Security",
      "changePassword": "Change Password",
      "changePasswordDesc": "Manage your account security",
      "logout": "Log Out",
      "logoutDesc": "Securely log out of this device"
    },
    "badges": {
      "soon": "Coming Soon"
    }
  },
  "ClassInsights": {
    "overview": "Overview",
    "examCount": "Exams",
    "subjectCount": "Subjects",
    "gradedCount": "Graded",
    "averageGrade": "Avg. grade",
    "averageGradeShort": "Avg. {{grade}}",
    "examListTitle": "Exams in this class",
    "noExams": "No exams in this class yet.",
    "loading": "Loading insights …",
    "statusGraded": "Graded",
    "statusInProgress": "In progress",
    "unnamedExam": "Unnamed exam",
    "unknownSubject": "Unknown subject"
  },
  "Classroom": {
    "title": "Classroom",
    "createButton": "Create class",
    "loading": "Loading…",
    "noClasses": "You haven't created any classes yet.",
    "pendingCount": "{{count}} pending",
    "copyCode": "Copy code",
    "copyLink": "Copy link",
    "joinCodeLabel": "Join code",
    "regenerateCode": "Regenerate code",
    "pendingRequestsTitle": "Pending requests",
    "noPendingRequests": "No pending requests.",
    "noPendingRequestsHint": "New join requests will show up here.",
    "rosterTitle": "Students",
    "noStudents": "No students yet.",
    "noStudentsHint": "Share the join code so your class shows up here.",
    "noClassesHint": "Create your first class to get started.",
    "studentCount_one": "{{count}} student",
    "studentCount_other": "{{count}} students",
    "approve": "Approve",
    "reject": "Reject",
    "studentOptions": "Options",
    "editStudent": "Edit",
    "removeStudent": "Remove",
    "showQrCode": "Show QR code",
    "qrCodeDialogTitle": "Join code",
    "qrCodeDialogHint": "Scan to join the class",
    "createDialog": {
      "title": "Create a new class",
      "namePlaceholder": "Class name, e.g. 10b Math",
      "cancel": "Cancel",
      "confirm": "Create"
    },
    "alerts": {
      "createError": "Failed to create class. Please try again.",
      "decideError": "Failed to update the request. Please try again.",
      "regenerateError": "Failed to regenerate the code. Please try again."
    }
  },
  "JoinClass": {
    "title": "Join class",
    "enterCodeTitle": "Enter a class code",
    "codePlaceholder": "ABC123",
    "findButton": "Find",
    "codeNotFound": "No class found for this code.",
    "confirmJoin": "Request to join \"{{className}}\"?",
    "requestButton": "Request to join",
    "alreadyRequested": "You've already requested to join \"{{className}}\".",
    "myClassesTitle": "My classes",
    "loading": "Loading…",
    "noClasses": "You haven't joined any classes yet.",
    "status": {
      "pending": "Pending",
      "approved": "Approved",
      "rejected": "Rejected"
    },
    "alerts": {
      "joinError": "Failed to send the join request. Please try again."
    }
  },
  "JoinLanding": {
    "loading": "Loading…",
    "noCode": "This link doesn't contain a class code.",
    "teacherAccountNotice": "This link is for joining a class as a student. You're currently signed in as a teacher.",
    "joinTitle": "Join \"{{className}}\"",
    "joinSubtitle": "Sign in or sign up to send your teacher a join request.",
    "codeNotFound": "This code wasn't found. Please check the link.",
    "signUpButton": "Sign up",
    "logInButton": "Log in"
  },
  "Dashboard": {
    "guestMessage": "I am gradi, your AI exam grading assistant.",
    "greetings": {
      "opt1": "Which exams are we grading today?",
      "opt2": "Let's tackle your stack of exams.",
      "opt3": "What's on the agenda today?",
      "opt4": "How can I help you today?",
      "opt5": "Great to see you. Where should we start?",
      "opt6": "Let's get grading!"
    },
    "studentGreetings": {
      "opt1": "What are we learning today?",
      "opt2": "Ready to tackle some exam questions?",
      "opt3": "What's on the agenda today?",
      "opt4": "How can I help you today?",
      "opt5": "Great to see you. Where should we start?",
      "opt6": "Let's get started!"
    },
    "fallbackGreeting": "What's on the agenda today?",
    "greetingPrefix": "Hi",
    "inputPlaceholder": "Ask a question...",
    "dropzoneText": "Drop files here",
    "actions": {
      "startGrading": {
        "label": "Start exam grading",
        "prompt": "I want to start a new exam grading. Please guide me step by step through the process from upload to the grading scheme."
      },
      "uploadExam": {
        "label": "Upload my exam",
        "prompt": "I'd like to upload an exam I've already completed so you can correct it for me. How do we get started?"
      },
      "createExam": {
        "label": "Create a practice exam",
        "prompt": "I'd like to create a new practice exam. Can you help me put one together?"
      },
      "howItWorks": {
        "label": "How does gradias work?",
        "prompt": "Please explain briefly how gradias works and what steps I need to take for a successful grading."
      },
      "sampleData": {
        "label": "Test with sample data",
        "prompt": "I want to test the system but don't have my own exams at hand. How can I test with a sample exam?"
      },
      "taskTypes": {
        "label": "What task types are there?",
        "prompt": "What types of tasks (e.g., free text, multiple choice, math equations) can you currently grade?"
      },
      "privacy": {
        "label": "Data Privacy and Security",
        "prompt": "How does gradias handle data privacy? What happens to the uploaded exams of my students?"
      }
    },
    "alerts": {
      "uploadError": "Error uploading file",
      "noExamId": "No examId present"
    },
    "aria": {
      "uploadFiles": "Upload files",
      "submit": "Submit",
      "removeFile": "Remove attached file"
    }
  },
  "ChatInput": {
    "statusLabels": {
      "allComplete": "All steps completed",
      "configRunning": "Done - Ready for next steps",
      "readyForConfig": "Ready for configuration",
      "status": "Status",
      "progress": "Progress",
      "inProgress": "in progress"
    },
    "steps": {
      "examCreator": {
        "label": "Create exam",
        "phasePlan": "Planning the exam",
        "phaseMaterial": "Generating figures",
        "phaseSource": "Writing tasks",
        "phaseRepair": "Finalizing the document"
      },
      "upload": {
        "label": "File Upload"
      },
      "studentAssignment": {
        "label": "Student Assignment",
        "activeWait": "Waiting for confirmation",
        "activeAssign": "Assign student submissions"
      },
      "structure": {
        "label": "Exam Structure",
        "active": "Detecting tasks"
      },
      "answers": {
        "label": "Student Answers",
        "active": "Processing answers"
      },
      "masterSolution": {
        "label": "Master Solution",
        "activeDetect": "Detecting master solution",
        "activeCreate": "Creating master solution",
        "activeComplete": "Completing master solution"
      },
      "gradingScheme": {
        "label": "Grading Scheme",
        "activeDetect": "Detecting grading criteria",
        "activeCreate": "Creating grading criteria",
        "activeComplete": "Completing grading criteria"
      },
      "grading": {
        "label": "Grading",
        "active": "Grading in progress"
      },
      "summary": {
        "label": "Result Overview"
      }
    },
    "badges": {
      "uncertainties": "Uncertainties",
      "errorRegions": "Error regions",
      "errorSubmissions": "Error submissions",
      "documentEncrypted": "Document encrypted"
    },
    "ui": {
      "showProgress": "Show grading progress",
      "dropFilesHere": "Drop files here",
      "uploadFiles": "Upload files",
      "waitUpload": "Wait for upload",
      "sendMessage": "Send message",
      "privacyNotice": "100% GDPR compliant. Your data and student documents are not used for AI training.",
      "learnMore": "Learn more."
    },
    "alerts": {
      "uploadError": "Error uploading file",
      "noExamId": "No examId present"
    }
  },
  "TokenInput": {
    "placeholder": "Ask a question..."
  },
  "Chat": {
    "auth": {
      "login": "Login",
      "register": "Sign up"
    },
    "loading": {
      "masterSolutions": "Loading master solutions...",
      "examData": "Loading exam data & images...",
      "extractingTasks": "Extracting tasks... {{finished}}/{{total}}",
      "splitThinkingMessage": "Assigning student submissions",
      "structureThinkingMessage": "Recognizing exam structure",
      "examStructure": "Loading exam structure...",
      "pages": "Loading pages...",
      "summary": "Loading summary..."
    },
    "alerts": {
      "errorOccurred": "Sorry, an error occurred. Please try again later.",
      "reportsBlocked": "PDF reports are only available once all main tasks are approved or have an AI confidence above {{threshold}}%.",
      "noSubmissionsForReports": "No submissions with report data found.",
      "reportsFailed": "Could not generate PDF reports. Please try again."
    },
    "sampleExamIntro": "I want to grade this exam with the following documents:\n{{lines}}",
    "canvasTitles": {
      "boundingbox": "Adjust bounding boxes",
      "msedit": "Edit master solution & grading scheme",
      "correction": "Grading",
      "summary": "Grading summary",
      "structureeditor": "Edit exam structure",
      "submissioncheck": "Verify page assignment",
      "demoselector": "Select demo",
      "examcreator": "Create exam",
      "default": "Detail view"
    }
  },
  "Canvas": {
    "common": {
      "resize": "Resize",
      "toSummaryTitle": "To summary",
      "backToSummary1": "Back to",
      "backToSummary2": "summary",
      "restore": "Restore",
      "fullscreen": "Fullscreen",
      "close": "Close",
      "emptyTitle": "Nothing to show yet",
      "emptyDescription": "Content will appear here once there's something to display."
    },
    "grading": {
      "prevTask": "Previous task",
      "nextTask": "Next task",
      "taskXofY": "Task {{current}} of {{total}}",
      "taskName": "Task {{number}}",
      "nextUncertainty": "Next uncertainty ({{count}})",
      "uncertaintiesLeft": "{{count}} uncertainties left",
      "backToSummary1": "Back to",
      "backToSummary2": "summary",
      "submissionX": "Submission {{id}}",
      "pages": "Pages:",
      "pageX": "Page {{page}}",
      "addBoundingBox": "Add new bounding box",
      "extractedText": "Extracted text",
      "verified": "Verified",
      "consistencyAdjusted": "Automatically adjusted for consistency with other submissions",
      "bboxConfidence": "BBox confidence: {{conf}}%",
      "review": "Review",
      "noTextExtracted": "No text extracted.",
      "imageContent": "Image (no text recognition) - the recognized image region will be used directly for further processing",
      "aiGrading": "AI Grading",
      "pts": "pts.",
      "points": "Points:",
      "noGradingYet": "No grading available yet.",
      "gradingScheme": "Grading scheme",
      "expand": "Expand",
      "collapse": "Collapse",
      "maxPoints": "Max points: {{points}}",
      "noGradingSchemeYet": "No grading scheme available yet.",
      "boxModeContent": "Content",
      "boxModeLanguageUse": "Language Use",
      "groupLanguageUseRule": "Group: task {{tasks}}",
      "groupLanguageUseRuleNumbered": "Group {{number}}: task {{tasks}}",
      "editLanguageUseGroupTasks": "Edit tasks in this group",
      "deleteLanguageUseGroup": "Delete this Language Use rule",
      "deleteLanguageUseGroupConfirm": "Delete this Language Use rule? This cannot be undone.",
      "deleteLanguageUseGroupBlocked": "Deletion is not possible while grading is in progress.",
      "languageUseGroupPickerInfo": "Check a task to add it to this group. Uncheck a task to remove it — if it still needs its own Language Use rule, it's pre-filled with this group's text and 0 points so you can find it again.",
      "languageUseGroupPickerSaveFailed": "Saving failed. Please try again.",
      "languageUseGroupPickerEmptyDraft": "A rule needs at least one task.",
      "deleteBox": "Delete bounding box",
      "retryOcr": "Retry text recognition",
      "unlockBox": "Unlock bounding box",
      "lockBox": "Lock bounding box",
      "noSubmissionsFound": "No submissions found.",
      "examPageX": "Exam page {{page}}",
      "modeCorrection": "Correction",
      "modeGrammar": "Grammar",
      "grammarTitle": "Spelling & Grammar",
      "grammarErrors": "Errors",
      "fehlerindex": "Error Index",
      "words": "Words",
      "noGrammarErrors": "No errors found.",
      "noGrammarEvaluationForTask": "No grammar evaluation for this task.",
      "notLocated": "Not located on the image",
      "notLocatedShort": "no marker",
      "deleteGrammarError": "Remove error",
      "editGrammarError": "Edit error",
      "saveGrammarError": "Save",
      "addMistake": "Add mistake",
      "mistakePlaceholder": "Error description…",
      "errorCategories": {
        "TYPOS": "Typos",
        "GRAMMAR": "Grammar",
        "SEMANTICS": "Semantics",
        "STYLE": "Style",
        "PUNCTUATION": "Punctuation",
        "TYPOGRAPHY": "Typography",
        "REDUNDANCY": "Redundancy",
        "CASING": "Capitalization",
        "COLLOCATIONS": "Collocations",
        "CONFUSED_WORDS": "Confused Words",
        "FALSE_FRIENDS": "False Friends",
        "GENDER_NEUTRALITY": "Gender Neutrality",
        "IDIOMS": "Idioms",
        "MISC": "Miscellaneous",
        "NONSTANDARD_PHRASES": "Non-standard Phrases",
        "PLAIN_ENGLISH": "Plain Language",
        "PROPER_NOUNS": "Proper Nouns",
        "REGIONALISMS": "Regionalisms"
      },
      "rerunningOcr": "Re-running text recognition...",
      "regrading": "Re-grading...",
      "regradingQueued": "Queued..."
    },
    "msgs": {
      "noTasksFound": "No tasks found.",
      "prevTask": "Previous task",
      "nextTask": "Next task",
      "task": "Task",
      "taskMain": "Task {{main}}",
      "taskSub": "Task {{main}}.{{sub}}",
      "uncertaintiesLeft": "{{count}} uncertainties left",
      "nextUncertainty": "Next uncertainty ({{count}})",
      "taskExcerpt": "Task excerpt",
      "noImageAvailable": "No image available...",
      "masterSolution": "Master solution",
      "aiGeneratedProposalTooltip": "Proposal generated by AI",
      "aiGeneratedProposal": "AI-generated proposal",
      "review": "Review",
      "approvalRequiresPoints": "Approval isn't possible until the points are greater than 0.",
      "saveRequiresPoints": "Saving isn't possible until the points are greater than 0.",
      "enterMasterSolution": "Enter master solution here...",
      "noMasterSolutionYet": "No master solution available yet...",
      "gradingScheme": "Grading scheme",
      "maxPoints": "Max points",
      "maxPointsValue": "Max points: {{points}}",
      "enterGradingScheme": "Enter grading scheme here...",
      "noGradingSchemeYet": "No grading scheme available yet...",
      "gradingSchemeRefining": "Updating grading scheme...",
      "masterSolutionRefining": "Updating master solution..."
    },
    "submissionCheck": {
      "pageShort": "P. {{page}}",
      "zoomPage": "Zoom page {{page}}",
      "pageAlt": "Page",
      "loading": "Loading...",
      "newStudent": "New student",
      "readOnly": "Read-only",
      "saveAssignment": "Save assignment",
      "unassignedPagesTitle": "Needs clarification: Unassigned pages ({{count}})",
      "unassignedPagesHint": "Please drag these pages into the students' folders.",
      "newStudentIndexed": "New student {{index}}",
      "studentIndexed": "Student {{index}}",
      "enterName": "Enter name...",
      "pageX_one": "{{count}} page",
      "pageX_other": "{{count}} pages",
      "splitConfidenceHover": "Split confidence: {{percent}}%",
      "splitPercent": "Split {{percent}}%",
      "deleteStudent": "Delete student",
      "dragHint": "Drag documents here to assign them to {{name}}",
      "assignmentNotes": "Assignment notes",
      "previewPageAlt": "Preview page {{page}}",
      "pageCurrentOfTotal": "Page {{current}} of {{total}}",
      "locked": "Confirmed",
      "lockedHint": "Already confirmed – can no longer be edited."
    },
    "summary": {
      "studentsOverview": "Student summary",
      "studentsOverviewDesc": "Detailed points and AI evaluation per task",
      "searchStudent": "Search student name...",
      "student": "Student",
      "pointsAbbr": "pts.",
      "total": "Total",
      "percentage": "Percentage",
      "grade": "Grade",
      "noHits": "No results.",
      "aiConfidenceHover": "AI confidence: {{percent}}% - Please review manually",
      "aiUncertainties": "AI Uncertainties",
      "aiUncertaintiesDesc": "Review cases where the AI is uncertain to ensure fair grading.",
      "openDecisions": "{{count}} open decisions",
      "sortBy": "Sort by",
      "task": "Task",
      "aiUncertainty": "AI uncertainty",
      "confidence": "AI confidence:",
      "points": "Points:",
      "toGrading": "Go to grading",
      "confirmed": "Confirmed",
      "confirm": "Confirm",
      "noClarificationNeeded": "No clarification needed.",
      "worstAvg": "Lowest average",
      "noDataYet": "No data yet",
      "avgSuffix": "on average",
      "frequentErrors": "Most frequent error sources",
      "metricsPerTask": "Metrics per task",
      "gradeDistribution": "Grade distribution",
      "count": "Count",
      "pdfReports": "PDF Reports",
      "downloadingPdf": "Generating PDF reports...",
      "downloadPdf": "Download PDF reports",
      "csvExport": "CSV Grade Export",
      "notConnected": "Not connected yet",
      "notMet": "Not met",
      "downloadingCsv": "Generating CSV...",
      "downloadCsv": "Download CSV",
      "gradeScale": "Grading scale",
      "gradeFrom": "Grade {{grade}} from",
      "normalDistribution": "Normal distribution (Bell curve)",
      "activated": "Activated",
      "deactivated": "Deactivated",
      "curveStrength": "Curving strength",
      "curvingComingSoon": "Curving is not yet available. This feature is coming soon.",
      "noSubmissionsFound": "No graded submissions found.",
      "avgPointsReached": "Ø Points achieved",
      "pointsReached": "Points achieved",
      "gradeSystem": "Grading system",
      "gradeBorders": "Grade borders",
      "lowestGradeLabel": "Lowest grade (from 0%)",
      "tabs": {
        "students": "Student overview",
        "clarification": "Clarification needed",
        "insights": "Task insights",
        "grades": "Grade distribution",
        "curving": "Grading key & Curving",
        "export": "Export",
        "languageUse": "Language Use & Grammar"
      },
      "gradingScales": {
        "german16": "German (1–6)",
        "drittel": "Thirds (1.0–5.0)",
        "af": "A–F",
        "gpa4": "4.0 GPA",
        "notenpunkte": "Grade Points (0–15)",
        "numeric10": "10-Point",
        "percentage": "Percentage",
        "custom": "Custom"
      },
      "grammar": "Grammar",
      "fehlerindex": "Error index (FI)",
      "grammarFiColumnHint": "Only includes tasks still graded via the error index; rule-graded tasks have their own columns.",
      "taskLanguageUseColumn": "{{label}} · Language Use",
      "grammarTab": {
        "noGrammarTasks": "This exam has no tasks with grammar evaluation.",
        "fiTitle": "Error index deduction",
        "fiDesc": "Error index = errors per 100 words. Exceeding the thresholds lowers the final grade by grade steps.",
        "fiUnsupportedScale": "Grade-step deductions are not available for percentage grading scales.",
        "fiAbove": "If error index above",
        "deductSteps": "deduct (grade steps)",
        "matrixTitle": "Grammar errors per student and task",
        "matrixDesc": "Number of errors (error index in parentheses). Clicking a cell opens the correction canvas in grammar mode.",
        "fiSwitchTitle": "Apply error index (Fehlerindex) for this exam",
        "fiSwitchDesc": "Defaults to your profile setting; toggle to override it for this exam only.",
        "gradeWithFi": "Grade (with FI)"
      },
      "languageUseTab": {
        "rulesOverviewTitle": "Language Use rules used in grading",
        "ownRuleEntry": "{{label}}: own rule ({{points}} pts)",
        "groupRuleEntry": "{{label}} ({{points}} pts)",
        "teacherRulesActive": "Language use is graded via your personal language-use rules directly during grading. The error index deduction is disabled."
      }
    },
    "structureEditor": {
      "noPages": "No pages available.",
      "taskAreasDetected_one": "{{count}} task area detected",
      "taskAreasDetected_other": "{{count}} task areas detected",
      "addArea": "Add area",
      "remove": "Remove",
      "resetZoom": "Reset zoom",
      "readOnly": "Read-only",
      "saving": "Saving...",
      "saved": "Saved",
      "blankExamPage": "Blank exam page {{page}}",
      "deleteBbx": "Delete BBX",
      "retryOcr": "Retry text recognition",
      "noTasksOnPage": "No tasks on this page",
      "task": "Task",
      "noText": "No text",
      "imageContent": "Image (no text recognition) - the recognized image region will be used directly for further processing",
      "additionalInfo": "Additional info",
      "noContent": "No content",
      "linkedTasks": "Linked tasks",
      "noTasks": "No tasks",
      "pointsInconsistent": "Points don't add up. On each level either give every task points (summing to the parent's total) or leave them all empty. Fix the highlighted tasks:",
      "pointsInconsistentTask": "Task {{path}} is missing points",
      "totalPoints": "Total points (incl. subtasks)",
      "ownPoints": "Own points (this task's own answer)",
      "tasksWithoutRegion": "Tasks without a marked region",
      "taskType": "Task type"
    },
    "demoSelector": {
      "title": "Select demo",
      "description": "Choose a sample exam. gradias simulates the upload and starts extraction automatically.",
      "examCount_one": "{{count}} exam",
      "examCount_other": "{{count}} exams",
      "studentCount_one": "{{count}} student",
      "studentCount_other": "{{count}} students",
      "examLanguage": "Exam language",
      "subjects": {
        "math": "Mathematics",
        "english": "English",
        "technical": "Vocational School",
        "biology": "Biology",
        "spanish": "Spanish",
        "french": "French",
        "physics": "Physics",
        "political_education": "Political education",
        "german": "German"
      },
      "grades": {
        "gesamtschule": "Comprehensive school",
        "highSchool": "Gymnasium",
        "elementarySchool": "Primary school",
        "vocationalSchool": "Vocational school / Adult education",
        "middleSchool": "Middle school",
        "university": "University",
        "primarySchool": "Primary school"
      },
      "exams": {
        "kaarst": {
          "name": "Math curve analysis",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "arne": {
          "name": "Math 6th grade fractions",
          "description": "Student submissions"
        },
        "lynehamMath": {
          "name": "Math",
          "description": "Student submissions"
        },
        "tuevBauleiter": {
          "name": "Construction site supervisor",
          "description": "Student submissions & master solution"
        },
        "tuvPhotovoltaik": {
          "name": "Photovoltaics",
          "description": "Student submissions & master solution"
        },
        "engVocabulary": {
          "name": "Vocabulary test (English)",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "bioImageLabeling": {
          "name": "Biology — Image Labeling",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "mathProofFr": {
          "name": "Mathematical Proof",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "mathProofEng": {
          "name": "Mathematical Proof",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "plotting": {
          "name": "Plotting",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "curveAnalysis": {
          "name": "Curve analysis",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "calculationDe": {
          "name": "Physics",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "dictationFr": {
          "name": "Dictation — French",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "dictationEs": {
          "name": "Dictation — Spanish",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "calculationFr": {
          "name": "Calculation",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "calculationEs": {
          "name": "Calculation",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "calculationEn": {
          "name": "Calculation",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "multipleChoiceDe": {
          "name": "Multiple choice",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "multipleChoiceEn": {
          "name": "Multiple choice",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "multipleChoiceFr": {
          "name": "Multiple choice",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "multipleChoiceEs": {
          "name": "Multiple choice",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "politics12German": {
          "name": "Political education — Grade 12",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "poetry12German": {
          "name": "Poetry analysis — Grade 12",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "poetry12English": {
          "name": "Poetry analysis — Grade 12",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "poetry12French": {
          "name": "Poetry analysis — Grade 12",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "materialBasedEnglish": {
          "name": "Material-based essay",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        },
        "materialBasedGerman": {
          "name": "Material-based essay",
          "description": "Complete set: student submissions, master solution, grading scheme & blank exam"
        }
      }
    },
    "examEditor": {
      "savingAndRecompiling": "Saving & recompiling…",
      "unsavedChanges": "Unsaved changes",
      "allChangesSaved": "All changes saved",
      "readOnlyBanner": "This exam is read-only: a master solution, grading scheme, or student submissions already exist that are based on the task structure, so it can no longer be changed here.",
      "generatingExam": "Generating exam…",
      "refiningExam": "Updating exam…",
      "downloadPdf": "Download PDF",
      "preparingPdf": "Preparing PDF…",
      "notSaved": "Not saved: {{message}}",
      "seeProblemsBelow": "see problems below",
      "noExam": "No exam.",
      "noSourceYet": "This exam has no source yet.",
      "noPreviewYet": "No compiled preview yet — click any block or dot to edit and generate one.",
      "tellAiPlaceholder": "Tell AI what to change ...",
      "delete": "Delete",
      "applying": "Applying …",
      "send": "Send",
      "done": "Done",
      "describeAiPlaceholder": "Describe to AI what task to add here ...",
      "add": "Add",
      "adding": "Adding …",
      "task": "Task {{number}}",
      "taskNumber": "Task Number",
      "type": "Type",
      "points": "Points",
      "lines": "Lines",
      "taskText": "Task text",
      "material": "Material",
      "title": "Title",
      "usedByTasks": "Used by tasks (comma-separated numbers)",
      "text": "Text",
      "multipleChoice": "Multiple choice",
      "removeOption": "Remove option",
      "addOption": "+ Add option",
      "figureProperties": "Figure Properties",
      "caption": "Caption",
      "examSetup": "Exam Setup",
      "subject": "Subject",
      "class": "Class",
      "duration": "Duration",
      "totalPoints": "Total Points",
      "globalHints": "Global Hints / Instructions",
      "studentView": "Fill in online"
    }
  },
  "TaskTypeDescs": {
    "taskFrame": "Groups subtasks; no direct student answer",
    "default": "General task type when no other fits",
    "shortText": "Short written answer (a few sentences)",
    "essay": "Long structured text, e.g. an essay",
    "diagram": "Technical drawing, e.g. flowchart or circuit",
    "sketch": "Freehand drawing or illustration",
    "gapText": "Fill in the blanks (cloze test)",
    "labelImage": "Label parts of an image or diagram",
    "multipleChoice": "Select from given options",
    "imageAnalysis": "Describe or analyze a provided image",
    "mapping": "Connect matching objects or alternatives",
    "legalCase": "Legal case analysis (Gutachtenstil)",
    "calculation": "Math or physics calculations",
    "mathematicalProof": "Formal mathematical proof",
    "curveAnalysis": "Function analysis (roots, extrema, …)",
    "plotting": "Plot a graph, function, or points in a coordinate system",
    "geometry": "Geometric constructions or calculations (drawing)",
    "programming": "Write or analyze source code",
    "art": "Create artwork or artistic design",
    "dictation": "Write down dictated text",
    "translation": "Translate text or words to another language",
    "chemicalFormula": "Chemical reaction equations or formulas",
    "music": "Read or write musical notation",
    "literaryAnalysisPoetry": "Analyse a poem",
    "analysisNonFiction": "Analyse a non-fiction text",
    "materialBasedEssay": "Write an essay based on provided materials"
  },
  "TaskTypes": {
    "taskFrame": "Task Frame",
    "default": "Default",
    "shortText": "Short text",
    "essay": "Essay",
    "diagram": "Diagram",
    "sketch": "Sketch",
    "gapText": "Gap text",
    "labelImage": "Label image",
    "multipleChoice": "Multiple choice",
    "imageAnalysis": "Image analysis",
    "mapping": "Mapping",
    "legalCase": "Legal case",
    "calculation": "Calculation",
    "mathematicalProof": "Mathematical proof",
    "curveAnalysis": "Curve analysis",
    "plotting": "Plotting",
    "geometry": "Geometry",
    "programming": "Programming",
    "art": "Art",
    "dictation": "Dictation",
    "translation": "Translation",
    "chemicalFormula": "Chemical formula",
    "music": "Music",
    "literaryAnalysisPoetry": "Poetry analysis",
    "analysisNonFiction": "Non-fiction analysis",
    "materialBasedEssay": "Material-based essay"
  },
  "GapText": {
    "gap": "Gap",
    "correct": "Correct",
    "incorrect": "Incorrect",
    "empty": "Empty",
    "points": "Points",
    "expectedAnswer": "Expected Answer",
    "studentAnswer": "Student Answer",
    "status": "Status"
  },
  "progress": {
    "analyzingSplit": "Analyzing split",
    "extractingAnswers": "Extracting student answers...",
    "errorExtractingAnswers": "Error extracting student answers",
    "answersExtracted": "Student answers extracted",
    "extractingMasterSolution": "Extracting master solution content",
    "errorStructureMasterSolution": "Error creating task structure (master solution)",
    "errorExtractingMasterSolution": "Error extracting master solution",
    "masterSolutionExtracted": "Master solution extracted",
    "extractingGradingScheme": "Extracting grading criteria",
    "errorStructureGradingScheme": "Error creating task structure (grading criteria)",
    "errorExtractingGradingScheme": "Error extracting grading criteria",
    "gradingSchemeExtracted": "Grading criteria extracted",
    "noUsableMasterSolution": "No usable master solution content detected. Please check file or adjust assignment.",
    "noUsableGradingScheme": "No usable grading criteria detected. Please check file or adjust assignment.",
    "analyzingStructure": "Analyzing exam structure",
    "noSubmissions": "No submissions found",
    "errorStructureAnalysis": "Error during exam structure analysis",
    "noTasksInStructure": "No tasks found in structure analysis",
    "extractingTaskDescriptions": "Extracting task descriptions",
    "errorTaskDescriptions": "Error extracting task descriptions",
    "taskDescriptionsExtracted": "Task descriptions extracted",
    "taskStructureCreated": "Task structure created",
    "waitingForStructureConfirmation": "Waiting for user to confirm exam structure",
    "structureConfirmed": "Exam structure confirmed",
    "structureConfirmationTimeout": "Exam structure confirmation timed out",
    "errorWaitingStructureConfirmation": "Error waiting for exam structure confirmation",
    "errorProcessingStructureConfirmation": "Error processing exam structure confirmation",
    "errorCreatingTaskStructure": "Error creating task structure",
    "pipelineFailedPrematurely": "Pipeline failed prematurely",
    "assignmentConfirmed": "Assignment confirmed",
    "gradingRunning": "Grading in progress...",
    "gradingTaskX": "Grading task {{taskNumber}} ...",
    "gradingCompleted": "Grading completed",
    "gradingTaskXCompleted": "Grading for task {{taskNumber}} completed"
  },
  "upload": {
    "noExamId": "No exam ID found",
    "noFileSelected": "No file selected",
    "processingFailed": "File could not be processed",
    "invalidFileType": "Invalid file type. Please select a PNG or PDF file.",
    "uploadError": "Error uploading file",
    "studentName": "Student {{index}}",
    "noExamIdForReupload": "Error: No exam ID available for re-upload.",
    "reuploadCancelled": "SYSTEM INFO: Upload cancellation processed.",
    "reuploadCancelFailed": "SYSTEM INFO: Upload cancellation could not be fully processed.",
    "filesMissing": "SYSTEM BLOCK: The following files were not found in the upload buffer: {{files}}. Please ensure the filenames exactly match the uploaded files.",
    "assignmentMismatch": "SYSTEM BLOCK: The following file assignments do not match the last proposal. Please call send_assignment_confirmation_message and confirm the new assignment with the user.\n{{lines}}",
    "reuploadStarted": "The file re-upload has started in the background. {{extra}}",
    "splitStarted": "Splitting started for student submissions.",
    "assignmentProposalSent": "Message with assignment proposal sent.",
    "assignmentConfirmationMessage": "I'm not entirely sure about the file assignment and will let you quickly check it.\n\nPlease confirm in the drag-and-drop area that the proposed assignment is correct, or adjust it there. After that, I can continue immediately.",
    "assignmentProposalFallback": "Please check my assignment proposal and confirm the file mapping.",
    "categorySubmissions": "Student submissions",
    "categoryMasterSolution": "Master solution",
    "categoryGradingScheme": "Grading scheme",
    "categoryBlankExam": "Blank exam",
    "lowConfidenceListFormat": "'{{file}}' (planned as {{category}})",
    "mismatchFormat": "- {{name}}: previously proposed as \"{{proposed}}\", now supplied as \"{{supplied}}\""
  },
  "splitIssues": {
    "unknownStudent": "Unknown student",
    "studentNumber": "Student {{number}}",
    "pageAssignmentError": "Not every page was assigned exactly once",
    "nonConsecutive": "Non-consecutive pages assigned for {{names}} (Reordered by agent)",
    "uncertainty": "Uncertainty with {{names}}",
    "outlierLongExtremeSingle": "Submission from {{names}} is extremely long",
    "outlierLongExtremePlural": "Submissions from {{names}} are extremely long",
    "outlierShortExtremeSingle": "Submission from {{names}} is extremely short",
    "outlierShortExtremePlural": "Submissions from {{names}} are extremely short",
    "outlierLongSingle": "Submission from {{names}} is unusually long",
    "outlierLongPlural": "Submissions from {{names}} are unusually long",
    "outlierShortSingle": "Submission from {{names}} is unusually short",
    "outlierShortPlural": "Submissions from {{names}} are unusually short",
    "missingStudentNameSingle": "Could not extract a name for {{missingCount}} out of {{totalCount}} student",
    "missingStudentNamePlural": "Could not extract a name for {{missingCount}} out of {{totalCount}} students",
    "splitAgentFailure": "Split agent error{{suffix}}",
    "errorPrefix": "Error",
    "warningPrefix": "Warning",
    "parseErrorFallback": "The data could not be processed. Please check the assignment in the canvas.",
    "messageError": "I found {{count}} students with {{range}} pages each, but an issue occurred during automatic page assignment:\n{{problem}}\n\nPlease review the assignment in the mapping canvas and correct it manually if needed. Once you are done, please confirm in the chat or via the button so we can continue.",
    "messageWarning": "I found {{count}} students with {{range}} pages each, but there are the following notices:\n{{problem}}\n\nIf you wish, you can review the notices in the mapping canvas. Otherwise, just confirm so we can continue.",
    "messageSuccess": "I found {{count}} students with {{range}} pages each. The assignment was unambiguous. A name could be extracted for all students. Please confirm so we can continue.",
    "confirmationRequested": "Split confirmation requested",
    "splitAgentFailed": "The automatic assignment of student submissions failed. Please try the upload again later."
  },
  "structureIssues": {
    "textCutoff": "Task text incomplete",
    "missingInformation": "Missing information",
    "imageUnreadable": "Image unreadable",
    "task": "Task",
    "mainTasks_one": "I identified {{mainCount}} main task.",
    "mainTasks_other": "I identified {{mainCount}} main tasks.",
    "mainAndSubTasks_one": "I identified {{mainCount}} main tasks and {{subCount}} subtask.",
    "mainAndSubTasks_other": "I identified {{mainCount}} main tasks and {{subCount}} subtasks.",
    "intro": "### I identified the following task structure:\n\n{{countText}}",
    "problemsIntro": "\n\nThe following issues occurred during task recognition: {{warnings}}. Please check the uncertainties in the canvas, edit them if necessary, and then confirm via the button or in the chat.",
    "uncertaintyIntro": "\n\nThere are uncertainties regarding {{labels}}. Please check the uncertainties in the canvas, edit them if necessary, and then confirm via the button or in the chat.",
    "success": "\n\nNo issues occurred during task recognition. If you wish, you can still review them in the canvas, otherwise please confirm via the button or in the chat.",
    "pointsExplanation": "\n\n**About the points:** I detected points for some tasks. If you upload a grading scheme with point details (or already have), the points will be taken from there – you can then ignore the points in the canvas. They only matter if your grading scheme doesn't contain them, or you want to have one generated.\n\nPoint rules: for each task, either give all direct subtasks points that sum to the parent task's total, or none. If you don't assign points to the subtasks but only a total, the AI will distribute them automatically later when generating the grading scheme."
  },
  "chatMessages": {
    "emptyState": "Start a conversation by typing a message below",
    "newMessage": "New message",
    "cancel": "Cancel",
    "send": "Send",
    "edit": "Edit",
    "editInCanvas": "Edit in Canvas",
    "confirmed": "Confirmed",
    "confirm": "Confirm",
    "confirmAssignment": "Confirm assignment",
    "giveFeedback": "Give Feedback",
    "feedbackTitle": "Give Feedback",
    "feedbackDescription": "Let us know how we can improve this answer.",
    "feedbackPlaceholder": "Your feedback here...",
    "feedbackSubmit": "Submit Feedback",
    "submitAssignmentConfirmation": "I confirm the split of the pages and the assignment to the students. Please proceed.",
    "submitStructureConfirmation": "I confirm the task structure of the exam.",
    "studentSubmissions": "Student Submissions",
    "masterSolution": "Master Solution",
    "gradingScheme": "Grading Scheme",
    "blankExam": "Blank Exam",
    "confirmedAssignmentIntro": "The confirmed file assignment:",
    "assignmentIntro": "I have assigned the files as follows. Please review and confirm the assignment:"
  },
  "AuthModal": {
    "loginError": "Incorrect email or password.",
    "signupFailed": "Registration failed. Please try again.",
    "passwordMismatch": "Passwords do not match.",
    "forgotPasswordProblem": "There was a problem. Please try again later.",
    "waitlistTitle": "You're on the list!",
    "waitlistDesc": "We will contact you as soon as the next phase begins.",
    "waitlistInactive": "Waitlist currently deactivated.",
    "backToLogin": "Back to login",
    "linkSentTitle": "Link sent!",
    "linkSentDesc": "Got it",
    "forgotPasswordTitle": "Forgot your password?",
    "requestLink": "Request link",
    "welcomeBack": "Welcome back",
    "createAccount": "Create an account",
    "emailLabel": "Email",
    "passwordLabel": "Password",
    "forgotPasswordLink": "Forgot password?",
    "loginButton": "Log In",
    "roleLabel": "I am a",
    "roleTeacher": "Teacher",
    "roleStudent": "Student",
    "firstNameLabel": "First Name",
    "lastNameLabel": "Last Name",
    "schoolLabel": "School",
    "subjectsLabel": "Subjects",
    "confirmPasswordLabel": "Confirm",
    "signupButton": "Sign Up",
    "registerHere": "Register here",
    "loginHere": "Log in here",
    "continueGuest": "Continue without logging in →"
  },
  "FeedbackPage": {
    "alerts": {
      "imageTooLarge": "The image \"{{name}}\" is too large (max. 5MB).",
      "previewError": "Preview could not be generated for {{name}}.",
      "submitError": "Something went wrong. Please try again."
    },
    "success": {
      "title": "Thank you for your feedback!",
      "description": "We have received your message. Your input helps us enormously to make Gradias a little bit better every day.",
      "backButton": "Back to exam"
    },
    "header": {
      "title": "Give Feedback"
    },
    "content": {
      "description": "Did you notice a bug, have a brilliant idea, or just want to tell us something? We read every message!"
    },
    "categories": {
      "title": "What is it about?",
      "bug": {
        "title": "Error / Bug",
        "desc": "Something is not working"
      },
      "feature": {
        "title": "Idea / Request",
        "desc": "A new feature"
      },
      "general": {
        "title": "Other",
        "desc": "General feedback"
      }
    },
    "message": {
      "title": "Your message",
      "placeholder": "Describe your request as detailed as possible..."
    },
    "upload": {
      "title": "Attach screenshot (Optional)",
      "clickToSelect": "Click to select images",
      "formatConstraint": "PNG, JPG up to max. 5MB per image",
      "attachedImages": "Attached images",
      "removeImage": "Remove image"
    },
    "submit": {
      "sending": "Sending...",
      "send": "Submit feedback"
    }
  },
  "ConfirmationReplies": {
    "split": {
      "confirmed": "The student assignment has been confirmed successfully. Task-structure extraction can now continue. Please thank the user for confirming the split and tell them that extraction is starting now.",
      "pending": "The student assignment is still waiting for confirmation."
    },
    "structure": {
      "masterAndGrading": "The task structure has been confirmed successfully. Extraction is now continuing in the background. A master solution and a grading scheme have already been uploaded and will be processed in the background. Please thank the user briefly for confirming the task structure and tell them that extraction is continuing. Suggest starting grading.",
      "masterOnly": "The task structure has been confirmed successfully. Extraction is now continuing in the background. A master solution has already been uploaded, but the grading scheme is still missing. Please thank the user briefly for confirming the task structure and tell them that extraction is continuing. Suggest generating an AI-based grading scheme next.",
      "gradingOnly": "The task structure has been confirmed successfully. Extraction is now continuing in the background. A grading scheme has already been uploaded, but the master solution is still missing. Please thank the user briefly for confirming the task structure and tell them that extraction is continuing. Suggest generating an AI-based master solution next.",
      "none": "The task structure has been confirmed successfully. Extraction is now continuing in the background. The master solution is still missing. Please thank the user briefly for confirming the task structure, tell them that extraction is continuing, and ask whether they want you to generate an AI-based master solution after extraction finishes or upload one via the paperclip in the chat input."
    },
    "errors": {
      "notConfirmed": "Confirmation flag is false; nothing to do.",
      "missingIdentifiers": "Missing required identifiers for confirmation.",
      "missingSplitMessage": "Error: No assigned split confirmation message found.",
      "missingStructureMessage": "Error: No assigned structure confirmation message found.",
      "structureContentMissing": "Error: Structure confirmation message could not be loaded.",
      "splitFailure": "Error confirming the split.",
      "structureFailure": "Error confirming the structure."
    }
  },
  "toolFallbackDesc": {
    "default": "Execute tool step",
    "set_metadata": "Set exam metadata",
    "create_exam": "Create exam now",
    "generate_master_solution": "Generate master solution",
    "refine_master_solution": "Refine master solution",
    "generate_grading_scheme": "Generate grading scheme",
    "refine_grading_scheme": "Refine grading scheme",
    "run_grading_agent": "Run grading agent",
    "set_task_score": "Set score manually",
    "open_canvas": "Open canvas view",
    "update_open_task_content": "Update open task",
    "send_assignment_confirmation_message": "Request assignment confirmation",
    "process_files": "Process uploaded files",
    "confirm_split_in_chat": "Confirm split in chat",
    "confirm_structure_in_chat": "Confirm structure in chat",
    "query_exams": "Query exams",
    "query_submissions": "Query submissions",
    "get_available_options": "Get available options",
    "get_task_types": "Get task types",
    "download_ms_gs": "Download master solution & scheme",
    "download_summary_reports": "Download summary reports",
    "save_teacher_memory": "Remember preference",
    "get_teacher_memory": "Look up preferences",
    "delete_teacher_memory": "Delete preferences",
    "reprocess_errored_submissions": "Reprocess failed submissions"
  },
  "Subjects": {
    "math": "Mathematics",
    "physics": "Physics",
    "chemistry": "Chemistry",
    "biology": "Biology",
    "history": "History",
    "geography": "Geography",
    "english": "English",
    "german": "German",
    "french": "French",
    "spanish": "Spanish",
    "computer_science": "Computer Science",
    "social_studies": "Social Studies",
    "other": "Other"
  },
  "ExamNotifications": {
    "newMessage": "New Message"
  },
  "LanguageUseTemplates": {
    "essay": "Proficiency Levels · Presentation Performance\n\n* outstanding:\n  - The text is clearly and logically structured, with effective connections between sections.\n  - Technical/subject-specific language is used confidently and precisely.\n  - Quotations are integrated correctly and introduced in context; evidence includes line references.\n  - Syntax is varied, stylistically assured, and appropriate to the literary subject matter.\n  - Grammar, spelling, and punctuation are nearly error-free.\n* good:\n  - The text is coherently structured.\n  - Technical/subject-specific language is used mostly confidently.\n  - Quotations are used appropriately and correctly referenced.\n  - Syntax is correct and varied.\n  - Few violations of grammar, spelling, and punctuation.\n* satisfactory:\n  - Structure is discernible but not consistently coherent throughout.\n  - Technical/subject-specific language is used functionally but not always precisely.\n  - Quotations are used, and references are mostly correct.\n  - Syntax is mostly correct, occasionally monotonous.\n  - Violations of grammar, spelling, and punctuation do not impair comprehension.\n* adequate:\n  - Structure is only rudimentarily discernible.\n  - Technical/subject-specific language is used only partially or imprecisely.\n  - Quotations are inconsistent or incompletely referenced.\n  - Syntax is monotonous, with frequent uncertainties.\n  - Linguistic accuracy is limited; comprehension is occasionally impeded.\n* deficient:\n  - The presentation is largely unstructured.\n  - Technical/subject-specific language is largely absent or used incorrectly.\n  - Quotations are missing or incorrect.\n  - Linguistic shortcomings significantly impair comprehension.\n* inadequate:\n  - The presentation is so deficient that the work is barely comprehensible.\n  - The basic requirements for a written literary interpretation essay are not discernible.",
    "analysisNonFiction": "Proficiency Levels · Presentation Performance\n\n* outstanding:\n  - The text is clearly and logically structured, with effective connections between sections.\n  - Technical/subject-specific language is used confidently and precisely.\n  - Quotations are integrated correctly and introduced in context; evidence includes line references.\n  - Syntax is varied, stylistically assured, and appropriate to the literary subject matter.\n  - Grammar, spelling, and punctuation are nearly error-free.\n* good:\n  - The text is coherently structured.\n  - Technical/subject-specific language is used mostly confidently.\n  - Quotations are used appropriately and correctly referenced.\n  - Syntax is correct and varied.\n  - Few violations of grammar, spelling, and punctuation.\n* satisfactory:\n  - Structure is discernible but not consistently coherent throughout.\n  - Technical/subject-specific language is used functionally but not always precisely.\n  - Quotations are used, and references are mostly correct.\n  - Syntax is mostly correct, occasionally monotonous.\n  - Violations of grammar, spelling, and punctuation do not impair comprehension.\n* adequate:\n  - Structure is only rudimentarily discernible.\n  - Technical/subject-specific language is used only partially or imprecisely.\n  - Quotations are inconsistent or incompletely referenced.\n  - Syntax is monotonous, with frequent uncertainties.\n  - Linguistic accuracy is limited; comprehension is occasionally impeded.\n* deficient:\n  - The presentation is largely unstructured.\n  - Technical/subject-specific language is largely absent or used incorrectly.\n  - Quotations are missing or incorrect.\n  - Linguistic shortcomings significantly impair comprehension.\n* inadequate:\n  - The presentation is so deficient that the work is barely comprehensible.\n  - The basic requirements for a written literary interpretation essay are not discernible.",
    "genericGroup": "Proficiency Levels · Presentation Performance\n\n* outstanding:\n  - The text is clearly and logically structured, with effective connections between sections.\n  - Technical/subject-specific language is used confidently and precisely.\n  - Quotations are integrated correctly and introduced in context; evidence includes line references.\n  - Syntax is varied, stylistically assured, and appropriate to the literary subject matter.\n  - Grammar, spelling, and punctuation are nearly error-free.\n* good:\n  - The text is coherently structured.\n  - Technical/subject-specific language is used mostly confidently.\n  - Quotations are used appropriately and correctly referenced.\n  - Syntax is correct and varied.\n  - Few violations of grammar, spelling, and punctuation.\n* satisfactory:\n  - Structure is discernible but not consistently coherent throughout.\n  - Technical/subject-specific language is used functionally but not always precisely.\n  - Quotations are used, and references are mostly correct.\n  - Syntax is mostly correct, occasionally monotonous.\n  - Violations of grammar, spelling, and punctuation do not impair comprehension.\n* adequate:\n  - Structure is only rudimentarily discernible.\n  - Technical/subject-specific language is used only partially or imprecisely.\n  - Quotations are inconsistent or incompletely referenced.\n  - Syntax is monotonous, with frequent uncertainties.\n  - Linguistic accuracy is limited; comprehension is occasionally impeded.\n* deficient:\n  - The presentation is largely unstructured.\n  - Technical/subject-specific language is largely absent or used incorrectly.\n  - Quotations are missing or incorrect.\n  - Linguistic shortcomings significantly impair comprehension.\n* inadequate:\n  - The presentation is so deficient that the work is barely comprehensible.\n  - The basic requirements for a written literary interpretation essay are not discernible.",
    "materialBasedEssay": "Material-based writing (composing argumentative / informative texts)\n\nContent performance & use of materials (comprehension performance / text structure):\n* The introduction is concise, arouses the reader's interest, and leads into the topic (clichéd transitions are avoided).\n* A sensible structure is discernible that corresponds to all the building blocks of the required target text type (e.g. commentary, essay, article).\n* The topic and the associated problem are clearly outlined at the outset.\n* Important basic terms are explained appropriately where needed.\n* All the materials provided are taken into account and incorporated into the text sensibly and with content accuracy.\n* Transparency regarding third-party statements is given (correct quoting, paraphrasing, and referencing of sources).\n* A clear distinction is made between presenting the facts, the argumentation, and one's own evaluation.\n* The argumentation is broad and differentiated (taking into account various aspects of the topic as well as possible counter-arguments).\n* Individual arguments are convincing for the target audience, clearly structured, explained, and supported with evidence/examples.\n* Alongside arguments from the materials, independent arguments and the student's own subject knowledge are contributed.\n* The argumentation is drawn together in a conclusion at the end, possibly followed by an outlook on the future.\n\nLinguistic performance & text design (presentation performance):\n* The linguistic design matches the required text type, with clear, precise language and independent formulations.\n* Vocabulary, command of technical terms, and functional style are precise, differentiated, and stylistically appropriate.\n* Sentence structure is manageable, varied, and grammatically complex.\n* Standard errors (in grammar, spelling, and punctuation) do not impair the flow of reading.",
    "literaryAnalysisPoetry": "Presentation Performance\n* 1. The candidate structures their text coherently, logically, consistently, and with clear reasoning:\n  - appropriate weighting of the sub-tasks in the execution\n  - a structured layout of the work with appropriate weighting\n  - a coherent connection between the individual working steps\n  - a coherent, logical connection between sentences\n* 2. The candidate formulates in accordance with the requirements of subject-specific language and methodology:\n  - separation of the level of action and the meta-level\n  - well-founded connection of descriptive, interpretive, and evaluative statements\n  - use of technical terminology in a meaningful context\n  - correct use of tense\n  - correct rendering of reported speech (modality)\n* 3. The candidate substantiates statements through appropriate and correct quoting:\n  - sensible use of complete or abridged quotations in a substantiating function\n* 4. The candidate expresses themselves with general linguistic precision, stylistic assurance, and conceptual differentiation:\n  - an objective, distanced writing style\n  - written-language register\n  - conceptually abstract expressive ability\n* 5. The candidate formulates with lexical and syntactic assurance, variety, and complexity (while remaining clear).\n* 6. The candidate writes with linguistic accuracy."
  },
  "LatexEditor": {
    "insertFormula": "Formula",
    "insertFormulaHint": "Insert a new formula at the cursor",
    "switchToRawLatex": "Switch to raw LaTeX",
    "switchToVisualEditor": "Switch to visual editor",
    "naturalLanguageHint": "Describe this formula in plain language",
    "naturalLanguagePlaceholder": "e.g. \"integral from 0 to 10 of x²\"",
    "naturalLanguageError": "Translation failed. Please try again.",
    "insert": "Insert",
    "removeFormula": "Remove formula",
    "cancel": "Cancel"
  },
  "StudentExam": {
    "loading": "Loading exam…",
    "examFallbackTitle": "Exam",
    "classLabel": "Class {{class}}",
    "namePlaceholder": "Your name",
    "answeredCount": "{{answered}} / {{total}} answered",
    "submit": "Submit",
    "signInRequiredTitle": "Sign-in required",
    "signInRequiredBody": "Sign in to work on this exam.",
    "signInAction": "Go to sign-in",
    "unavailableTitle": "Not available",
    "submittedTitle": "Submitted",
    "submittedBody": "Your answers have been saved and are ready for marking.",
    "errors": {
      "loadFailed": "The exam could not be loaded.",
      "notFound": "This exam does not exist.",
      "notSignedIn": "Not signed in.",
      "noAccess": "Exam not found, or no access.",
      "noTasks": "This exam has no tasks yet.",
      "uploadedExam": "This exam was uploaded rather than created, so it cannot be filled in online.",
      "studentsOnly": "Filling this out online is only available for student accounts.",
      "renderFailed": "The exam could not be displayed.",
      "unreadableAnswers": "Your answers could not be read.",
      "submitFailed": "Submission failed."
    },
    "canvas": {
      "undo": "Undo",
      "clear": "Clear",
      "pen": "Pen",
      "eraser": "Eraser",
      "redo": "Redo",
      "zoom": "Draw enlarged",
      "zoomClose": "Close enlarged view",
      "penWidth": "Pen width {{width}}"
    }
  }
}
